import { render, staticRenderFns } from "./HomeClaim12t.vue?vue&type=template&id=4d9d5df0&scoped=true&"
import script from "./HomeClaim12t.vue?vue&type=script&lang=js&"
export * from "./HomeClaim12t.vue?vue&type=script&lang=js&"
import style0 from "./HomeClaim12t.vue?vue&type=style&index=0&id=4d9d5df0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d5df0",
  null
  
)

export default component.exports